import styled from 'styled-components';

const TableBody = styled.tbody`
  width: 100%;
`;

export default TableBody;
